import { IBaseComponentProps } from '../types';
import { IDateParts, IDateFormat, IDate, NameLength } from '@agilepoint/utils-date-time';

export enum Day {
    mon = 1,
    tue = 2,
    wed = 3,
    thu = 4,
    fri = 5,
    sat = 6,
    sun = 7
}

export interface ICalendarRenderItemProps {
    dateInfo: IDateInfo;
    isSelected?: boolean;
    isToday?: boolean;
    isDisabled: boolean;
    onClick: () => void;
}

export interface ICalendarOnRenderItem {
    onRenderItem?(props: ICalendarRenderItemProps): React.ReactNode;
}

export interface ICalendarProps extends IBaseComponentProps<HTMLDivElement>, ICalendarOnRenderItem {
    /**
     * Class name for calendar
     */
    className?: string;
    /**
     * Default value of the calendar
     */
    defaultValue?: IDate | IDate[];
    /**
     * Number of months in view. Maximum value is 3.
     * @default 1
     */
    numberOfMonthsInView?: number;
    /**
     * Format of the date, defaults to local date format
     */
    format?: IDateFormat;
    /**
     * Set `true` to hide date from other month
     */
    hideDateFromOtherMonth?: boolean;
    /**
     * Maximum date which can be selected
     */
    maxDate?: IDate;
    /**
     * Minimum date which can be selected
     */
    minDate?: IDate;
    /**
     * Value of the calendar
     */
    value?: IDate | IDate[];
    /**
     * Start day of the week for display
     */
    weekStartDay?: Day;
    /**
     * Show week number
     */
    showWeekNumber?: boolean;
    /**
     * Show or hide today button
     */
    showTodayButton?: boolean;
    /**
     * Selection mode of the calendar
     */
    selectionMode?: SelectionMode;
    /**
     * Calendar view type
     */
    view?: CalendarView;
    /**
     * Start year of the calandar
     */
    startYear?: number;
    /**
     * End year of the calandar
     */
    endYear?: number;
    /**
     * Representation of week days of type NameLength, defaults to 'short'
     */
    weekDayNameLength?: NameLength;
    /**
     * On Change handler
     */
    localization?: {
        /**
         * Label for today button, default value is 'Today'
         */
        todayLabel?: string;
        /**
         * Title for previous month button, default value is 'Previous Month'
         */
        previousMonthTitle?: string;
        /**
         * Title for next month button, default value is 'Next Month'
         */
        nextMonthTitle?: string;
    }
    onChange?(value: Date[]): void;
    /**
     * On view change Handler
     */
    onViewChange?(view: CalendarView): void;
    /**
     * On date cell mouseover handler
     */
    onDateCellMouseOver?(info: IDateInfo): void;
}

export interface IDateInfo extends IDateParts {
    isInCurentMonth: boolean;
}

export type SelectionMode = 'single' | 'range' | 'multiple';

export type CalendarView = Omit<IDateParts, 'date'>;
